/**
 * Copyright ToolBelt Data Inc., 2021 All Rights Reserved
 */

import React from 'react';
import styled from "styled-components";
import TextHoverDisplay from './TextHoverDisplay';

const UuidWrapper = styled.div `
  max-width: 140px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;

const UuidColumn = ({ uuid, truncateLength = 13 }) => {
  if (!uuid) {
    return <span></span>;
  }

  return (
    <UuidWrapper>
      <TextHoverDisplay
        truncatedText={uuid.substring(0, truncateLength)}
        fullText={uuid}
        minWidth={120}
      />
    </UuidWrapper>
  );
};

export default UuidColumn;
